export default [
    {
        path: 'relatorio-papel-lotacao',
        component: () => import(/* webpackChunkName: 'administracao-relatorio-papel-lotacao' */ '@/views/administracao/relatorio-papel-lotacao/Index'),
        redirect: 'relatorio-papel-lotacao/index',
        children: [
            {
                name: 'administracao-relatorio-papel-lotacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-relatorio-papel-lotacao' */ '@/views/administracao/relatorio-papel-lotacao/List'),
            },
        ]
    }
]